/**
 * @fileoverview > handler for the "/engagement/approvals/:context_id/:step" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementApprovalsContextIdStepCacheKeys } from "./constants";
import type {
  PatchEngagementApprovalsContextIdStepProps,
  EngagementApprovalsContextIdStepMutationResult,
} from "./types";

export const patchEngagementApprovalsStep = reactQueryMutationAdapter(
  engagementApprovalsContextIdStepCacheKeys,
  (props: PatchEngagementApprovalsContextIdStepProps): Promise<EngagementApprovalsContextIdStepMutationResult> => {
    return fetch(`/engagement/approvals/${props.contextId}/${props.step}`, "PATCH", {
      context_type: props.contextType,
      status: props.status,
      is_messaging_rule_approval_only: props.isMessagingRuleApprovalOnly,
    });
  }
);
